import "./cadastro-participantes-vila-pinto.b081ef1c.js";
import "./firebase-init-pc.49251f90.js";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiree555"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiree555"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("dCqD9", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");

var $hPtJY = parcelRequire("hPtJY");
window.Buffer = (0, $6ZWSX.Buffer);
window.process = (0, (/*@__PURE__*/$parcel$interopDefault($hPtJY)));

});
parcelRegister("hPtJY", function(module, exports) {
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = 'browser';
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ''; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return '/';
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};

});


parcelRequire("dCqD9");

var $hEplm = parcelRequire("hEplm");

var $ilpIi = parcelRequire("ilpIi");
/* =========================
   CONFIG DINÂMICA
========================= */ const $80c2d91c338af4a4$var$BODY = document.body;
const $80c2d91c338af4a4$var$CONFIG = {
    territoryId: String($80c2d91c338af4a4$var$BODY.dataset.territoryId || "").trim(),
    territoryLabel: String($80c2d91c338af4a4$var$BODY.dataset.territoryLabel || "").trim(),
    territorySlug: String($80c2d91c338af4a4$var$BODY.dataset.territorySlug || "").trim(),
    redirectAfterSuccess: String($80c2d91c338af4a4$var$BODY.dataset.redirectUrl || "index.html").trim(),
    viacepBase: "https://viacep.com.br/ws",
    nominatimBase: "https://nominatim.openstreetmap.org/search"
};
const $80c2d91c338af4a4$var$CODE_CONFIG = {
    "vila-pinto": {
        casa: {
            prefix: "VPD",
            start: 300
        },
        condominio: {
            prefix: "VPCD",
            start: 10
        },
        comercio: {
            prefix: "VPCM",
            start: 10
        },
        outro: {
            prefix: "VPO",
            start: 300
        }
    },
    "cooadesc": {
        casa: {
            prefix: "COD",
            start: 1
        },
        condominio: {
            prefix: "COCD",
            start: 1
        },
        comercio: {
            prefix: "COCM",
            start: 1
        },
        outro: {
            prefix: "COO",
            start: 1
        }
    },
    "padre-cacique": {
        casa: {
            prefix: "PCD",
            start: 1
        },
        condominio: {
            prefix: "PCCD",
            start: 1
        },
        comercio: {
            prefix: "PCCM",
            start: 1
        },
        outro: {
            prefix: "PCO",
            start: 1
        }
    }
};
/* =========================
   STATE
========================= */ const $80c2d91c338af4a4$var$STATE = {
    currentStep: 1,
    totalSteps: 4,
    localType: "casa",
    registerType: "participante",
    generatedCode: "",
    consentAccepted: false,
    isSubmitting: false,
    geoRequestId: 0,
    geo: {
        lat: null,
        lng: null,
        addressLabel: ""
    }
};
/* =========================
   ELEMENTOS
========================= */ const $80c2d91c338af4a4$var$$ = (id)=>document.getElementById(id);
const $80c2d91c338af4a4$var$els = {
    form: $80c2d91c338af4a4$var$$("participantWizardForm"),
    formMessage: $80c2d91c338af4a4$var$$("formMessage"),
    stepIndicator: $80c2d91c338af4a4$var$$("stepIndicator"),
    progressText: $80c2d91c338af4a4$var$$("progressText"),
    progressBarFill: $80c2d91c338af4a4$var$$("progressBarFill"),
    territoryLabelView: $80c2d91c338af4a4$var$$("territoryLabelView"),
    userNameView: $80c2d91c338af4a4$var$$("userNameView"),
    consentLgpd: $80c2d91c338af4a4$var$$("consentLgpd"),
    consentWhatsapp: $80c2d91c338af4a4$var$$("consentWhatsapp"),
    consentImage: $80c2d91c338af4a4$var$$("consentImage"),
    btnAcceptAllConsents: $80c2d91c338af4a4$var$$("btnAcceptAllConsents"),
    consentAcceptedNote: $80c2d91c338af4a4$var$$("consentAcceptedNote"),
    fullName: $80c2d91c338af4a4$var$$("fullName"),
    phone: $80c2d91c338af4a4$var$$("phone"),
    email: $80c2d91c338af4a4$var$$("email"),
    cpf: $80c2d91c338af4a4$var$$("cpf"),
    localTypeGroup: $80c2d91c338af4a4$var$$("localTypeGroup"),
    registerTypeGroup: $80c2d91c338af4a4$var$$("registerTypeGroup"),
    generatedCode: $80c2d91c338af4a4$var$$("generatedCode"),
    cep: $80c2d91c338af4a4$var$$("cep"),
    btnBuscarCep: $80c2d91c338af4a4$var$$("btnBuscarCep"),
    number: $80c2d91c338af4a4$var$$("number"),
    street: $80c2d91c338af4a4$var$$("street"),
    neighborhood: $80c2d91c338af4a4$var$$("neighborhood"),
    city: $80c2d91c338af4a4$var$$("city"),
    state: $80c2d91c338af4a4$var$$("state"),
    referencePoint: $80c2d91c338af4a4$var$$("referencePoint"),
    geoPreview: $80c2d91c338af4a4$var$$("geoPreview"),
    latLngPreview: $80c2d91c338af4a4$var$$("latLngPreview"),
    difficultyGroup: $80c2d91c338af4a4$var$$("difficultyGroup"),
    householdMembers: $80c2d91c338af4a4$var$$("householdMembers"),
    projectSource: $80c2d91c338af4a4$var$$("projectSource"),
    projectSourceOther: $80c2d91c338af4a4$var$$("projectSourceOther"),
    successModal: $80c2d91c338af4a4$var$$("successModal"),
    closeSuccessModal: $80c2d91c338af4a4$var$$("closeSuccessModal"),
    newParticipantRegistration: $80c2d91c338af4a4$var$$("newParticipantRegistration"),
    menuToggle: $80c2d91c338af4a4$var$$("menuToggle"),
    mobileMenu: $80c2d91c338af4a4$var$$("mobileMenu"),
    btnSubmitParticipant: $80c2d91c338af4a4$var$$("btnSubmitParticipant")
};
/* =========================
   HELPERS
========================= */ function $80c2d91c338af4a4$var$onlyDigits(value = "") {
    return String(value).replace(/\D/g, "");
}
function $80c2d91c338af4a4$var$slugify(value = "") {
    return String(value).normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().trim().replace(/\s+/g, "-");
}
function $80c2d91c338af4a4$var$normalizeName(name = "") {
    return String(name).normalize("NFD").replace(/[\u0300-\u036f]/g, "").trim().replace(/\s+/g, " ");
}
function $80c2d91c338af4a4$var$capitalizeWords(text = "") {
    return String(text).toLowerCase().replace(/\b\w/g, (m)=>m.toUpperCase());
}
function $80c2d91c338af4a4$var$showMessage(message, type = "info") {
    if (!$80c2d91c338af4a4$var$els.formMessage) return;
    $80c2d91c338af4a4$var$els.formMessage.classList.remove("hidden", "error", "success", "info", "warning");
    $80c2d91c338af4a4$var$els.formMessage.classList.add(type);
    $80c2d91c338af4a4$var$els.formMessage.textContent = message;
    window.scrollTo({
        top: 0,
        behavior: "smooth"
    });
}
function $80c2d91c338af4a4$var$clearMessage() {
    if (!$80c2d91c338af4a4$var$els.formMessage) return;
    $80c2d91c338af4a4$var$els.formMessage.classList.add("hidden");
    $80c2d91c338af4a4$var$els.formMessage.textContent = "";
    $80c2d91c338af4a4$var$els.formMessage.classList.remove("error", "success", "info", "warning");
}
function $80c2d91c338af4a4$var$setLoading(button, isLoading, loadingText = "Salvando...") {
    if (!button) return;
    if (isLoading) {
        if (!button.dataset.originalText) button.dataset.originalText = button.textContent;
        button.disabled = true;
        button.textContent = loadingText;
    } else {
        button.disabled = false;
        button.textContent = button.dataset.originalText || "Salvar";
    }
}
function $80c2d91c338af4a4$var$formatPhone(value = "") {
    const digits = $80c2d91c338af4a4$var$onlyDigits(value).slice(0, 11);
    if (digits.length <= 2) return digits;
    if (digits.length <= 7) return `(${digits.slice(0, 2)}) ${digits.slice(2)}`;
    return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`;
}
function $80c2d91c338af4a4$var$formatCPF(value = "") {
    const digits = $80c2d91c338af4a4$var$onlyDigits(value).slice(0, 11);
    if (digits.length <= 3) return digits;
    if (digits.length <= 6) return `${digits.slice(0, 3)}.${digits.slice(3)}`;
    if (digits.length <= 9) return `${digits.slice(0, 3)}.${digits.slice(3, 6)}.${digits.slice(6)}`;
    return `${digits.slice(0, 3)}.${digits.slice(3, 6)}.${digits.slice(6, 9)}-${digits.slice(9, 11)}`;
}
function $80c2d91c338af4a4$var$formatCEP(value = "") {
    const digits = $80c2d91c338af4a4$var$onlyDigits(value).slice(0, 8);
    if (digits.length <= 5) return digits;
    return `${digits.slice(0, 5)}-${digits.slice(5)}`;
}
function $80c2d91c338af4a4$var$isValidEmail(email = "") {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(email).trim());
}
function $80c2d91c338af4a4$var$isValidCPF(cpf = "") {
    const digits = $80c2d91c338af4a4$var$onlyDigits(cpf);
    if (!digits) return true;
    if (digits.length !== 11) return false;
    if (/^(\d)\1+$/.test(digits)) return false;
    let sum = 0;
    for(let i = 0; i < 9; i++)sum += Number(digits[i]) * (10 - i);
    let firstDigit = sum * 10 % 11;
    if (firstDigit === 10) firstDigit = 0;
    if (firstDigit !== Number(digits[9])) return false;
    sum = 0;
    for(let i = 0; i < 10; i++)sum += Number(digits[i]) * (11 - i);
    let secondDigit = sum * 10 % 11;
    if (secondDigit === 10) secondDigit = 0;
    if (secondDigit !== Number(digits[10])) return false;
    return true;
}
/* =========================
   CONFIG AUXILIAR
========================= */ function $80c2d91c338af4a4$var$getCanonicalTerritoryId() {
    return $80c2d91c338af4a4$var$CONFIG.territoryId;
}
function $80c2d91c338af4a4$var$getCanonicalTerritoryLabel() {
    return $80c2d91c338af4a4$var$CONFIG.territoryLabel;
}
function $80c2d91c338af4a4$var$getCodeTerritoryKey() {
    return String($80c2d91c338af4a4$var$CONFIG.territorySlug || $80c2d91c338af4a4$var$CONFIG.territoryId || "").toLowerCase().replace(/^crgr_/, "").replace(/_/g, "-").trim();
}
function $80c2d91c338af4a4$var$getCodeLocalType() {
    const localType = String($80c2d91c338af4a4$var$STATE.localType || "casa").trim();
    if (localType === "condominio") return "condominio";
    if (localType === "comercio") return "comercio";
    if (localType === "outro") return "outro";
    return "casa";
}
function $80c2d91c338af4a4$var$assertRuntimeConfig() {
    if (!$80c2d91c338af4a4$var$CONFIG.territoryId || !$80c2d91c338af4a4$var$CONFIG.territoryLabel) throw new Error("Configura\xe7\xe3o do territ\xf3rio ausente. Verifique os atributos data-territory-id e data-territory-label no body.");
}
/* =========================
   CÓDIGO SEQUENCIAL
========================= */ async function $80c2d91c338af4a4$var$generateSequentialCode() {
    const territoryKey = $80c2d91c338af4a4$var$getCodeTerritoryKey();
    const localTypeKey = $80c2d91c338af4a4$var$getCodeLocalType();
    const config = $80c2d91c338af4a4$var$CODE_CONFIG[territoryKey]?.[localTypeKey];
    if (!config) throw new Error(`Configura\xe7\xe3o de c\xf3digo n\xe3o encontrada para ${territoryKey}/${localTypeKey}.`);
    const { prefix: prefix, start: start } = config;
    const q = (0, $ilpIi.query)((0, $ilpIi.collection)((0, $hEplm.db), "participants"), (0, $ilpIi.where)("territoryId", "==", $80c2d91c338af4a4$var$getCanonicalTerritoryId()), (0, $ilpIi.where)("codeLocalType", "==", localTypeKey));
    const snapshot = await (0, $ilpIi.getDocs)(q);
    let maxNumber = 0;
    snapshot.forEach((docSnap)=>{
        const data = docSnap.data() || {};
        const code = String(data.participantCode || "").trim();
        if (!code.startsWith(`${prefix}-`)) return;
        const numberPart = Number(code.split("-")[1]);
        if (Number.isFinite(numberPart) && numberPart > maxNumber) maxNumber = numberPart;
    });
    const nextNumber = Math.max(start, maxNumber + 1);
    return `${prefix}-${String(nextNumber).padStart(4, "0")}`;
}
function $80c2d91c338af4a4$var$getRegisterTypeByLocalType(localType) {
    return localType === "condominio" ? "condominio" : "participante";
}
/* =========================
   GEO PREVIEW
========================= */ function $80c2d91c338af4a4$var$updateGeoPreview() {
    if ($80c2d91c338af4a4$var$els.geoPreview) $80c2d91c338af4a4$var$els.geoPreview.textContent = $80c2d91c338af4a4$var$STATE.geo.addressLabel || "ainda n\xe3o calculado";
    if ($80c2d91c338af4a4$var$els.latLngPreview) {
        if ($80c2d91c338af4a4$var$STATE.geo.lat != null && $80c2d91c338af4a4$var$STATE.geo.lng != null) $80c2d91c338af4a4$var$els.latLngPreview.textContent = `${$80c2d91c338af4a4$var$STATE.geo.lat}, ${$80c2d91c338af4a4$var$STATE.geo.lng}`;
        else $80c2d91c338af4a4$var$els.latLngPreview.textContent = "ainda n\xe3o calculado";
    }
}
function $80c2d91c338af4a4$var$resetGeo() {
    $80c2d91c338af4a4$var$STATE.geo = {
        lat: null,
        lng: null,
        addressLabel: ""
    };
    $80c2d91c338af4a4$var$updateGeoPreview();
}
/* =========================
   TIPO DE LOCAL / CÓDIGO
========================= */ function $80c2d91c338af4a4$var$syncRegisterTypeUI() {
    const buttons = $80c2d91c338af4a4$var$els.registerTypeGroup?.querySelectorAll("[data-register-type]") || [];
    buttons.forEach((btn)=>{
        const registerType = btn.dataset.registerType;
        const isSelected = registerType === $80c2d91c338af4a4$var$STATE.registerType;
        const shouldBeDisabled = $80c2d91c338af4a4$var$STATE.localType === "condominio" ? registerType !== "condominio" : registerType === "condominio";
        btn.classList.toggle("selected", isSelected);
        btn.classList.toggle("is-disabled", shouldBeDisabled);
        btn.setAttribute("aria-pressed", isSelected ? "true" : "false");
    });
}
async function $80c2d91c338af4a4$var$setRegisterType(registerType, regenerate = true) {
    $80c2d91c338af4a4$var$STATE.registerType = registerType;
    if (regenerate || !$80c2d91c338af4a4$var$STATE.generatedCode) $80c2d91c338af4a4$var$STATE.generatedCode = await $80c2d91c338af4a4$var$generateSequentialCode();
    if ($80c2d91c338af4a4$var$els.generatedCode) $80c2d91c338af4a4$var$els.generatedCode.value = $80c2d91c338af4a4$var$STATE.generatedCode;
    $80c2d91c338af4a4$var$syncRegisterTypeUI();
}
async function $80c2d91c338af4a4$var$setLocalType(localType) {
    $80c2d91c338af4a4$var$STATE.localType = localType;
    const buttons = $80c2d91c338af4a4$var$els.localTypeGroup?.querySelectorAll("[data-local-type]") || [];
    buttons.forEach((btn)=>{
        const selected = btn.dataset.localType === localType;
        btn.classList.toggle("selected", selected);
        btn.setAttribute("aria-pressed", selected ? "true" : "false");
    });
    const autoRegisterType = $80c2d91c338af4a4$var$getRegisterTypeByLocalType(localType);
    try {
        await $80c2d91c338af4a4$var$setRegisterType(autoRegisterType, true);
    } catch (error) {
        console.warn("N\xe3o foi poss\xedvel gerar o c\xf3digo neste momento:", error);
        if ($80c2d91c338af4a4$var$els.generatedCode) $80c2d91c338af4a4$var$els.generatedCode.value = "Ser\xe1 gerado ao concluir";
    }
}
/* =========================
   STEPS
========================= */ function $80c2d91c338af4a4$var$getStepCards() {
    return Array.from(document.querySelectorAll(".step-card"));
}
function $80c2d91c338af4a4$var$updateProgress() {
    if ($80c2d91c338af4a4$var$els.stepIndicator) $80c2d91c338af4a4$var$els.stepIndicator.textContent = `Etapa ${$80c2d91c338af4a4$var$STATE.currentStep} de ${$80c2d91c338af4a4$var$STATE.totalSteps}`;
    if ($80c2d91c338af4a4$var$els.progressText) $80c2d91c338af4a4$var$els.progressText.textContent = `Progresso: ${$80c2d91c338af4a4$var$STATE.currentStep}/${$80c2d91c338af4a4$var$STATE.totalSteps}`;
    if ($80c2d91c338af4a4$var$els.progressBarFill) {
        const pct = $80c2d91c338af4a4$var$STATE.currentStep / $80c2d91c338af4a4$var$STATE.totalSteps * 100;
        $80c2d91c338af4a4$var$els.progressBarFill.style.width = `${pct}%`;
    }
    $80c2d91c338af4a4$var$getStepCards().forEach((card)=>{
        const step = Number(card.dataset.step);
        const isActive = step === $80c2d91c338af4a4$var$STATE.currentStep;
        card.classList.toggle("is-active", isActive);
        card.classList.toggle("hidden", !isActive);
    });
}
function $80c2d91c338af4a4$var$goToStep(step) {
    if (step < 1 || step > $80c2d91c338af4a4$var$STATE.totalSteps) return;
    $80c2d91c338af4a4$var$STATE.currentStep = step;
    $80c2d91c338af4a4$var$updateProgress();
    $80c2d91c338af4a4$var$clearMessage();
    window.scrollTo({
        top: 0,
        behavior: "smooth"
    });
}
/* =========================
   VALIDAÇÃO
========================= */ function $80c2d91c338af4a4$var$validateStep1() {
    if (!$80c2d91c338af4a4$var$STATE.consentAccepted) {
        $80c2d91c338af4a4$var$showMessage("Para continuar, clique em \u201CConcordo com todas as autoriza\xe7\xf5es\u201D.", "error");
        $80c2d91c338af4a4$var$els.btnAcceptAllConsents?.focus();
        return false;
    }
    return true;
}
function $80c2d91c338af4a4$var$validateStep2() {
    const fullName = $80c2d91c338af4a4$var$normalizeName($80c2d91c338af4a4$var$els.fullName?.value);
    const phone = $80c2d91c338af4a4$var$onlyDigits($80c2d91c338af4a4$var$els.phone?.value);
    const email = String($80c2d91c338af4a4$var$els.email?.value || "").trim();
    const cpf = String($80c2d91c338af4a4$var$els.cpf?.value || "").trim();
    if (!fullName || fullName.length < 5) {
        $80c2d91c338af4a4$var$showMessage("Informe o nome completo corretamente.", "error");
        $80c2d91c338af4a4$var$els.fullName?.focus();
        return false;
    }
    if (phone.length < 10 || phone.length > 11) {
        $80c2d91c338af4a4$var$showMessage("Informe um telefone/WhatsApp v\xe1lido com DDD.", "error");
        $80c2d91c338af4a4$var$els.phone?.focus();
        return false;
    }
    if (email && !$80c2d91c338af4a4$var$isValidEmail(email)) {
        $80c2d91c338af4a4$var$showMessage("O e-mail informado n\xe3o \xe9 v\xe1lido. Corrija ou deixe o campo em branco.", "error");
        $80c2d91c338af4a4$var$els.email?.focus();
        return false;
    }
    if (cpf && !$80c2d91c338af4a4$var$isValidCPF(cpf)) {
        $80c2d91c338af4a4$var$showMessage("O CPF informado n\xe3o \xe9 v\xe1lido. Corrija ou deixe o campo em branco.", "error");
        $80c2d91c338af4a4$var$els.cpf?.focus();
        return false;
    }
    return true;
}
function $80c2d91c338af4a4$var$validateStep3() {
    const referencePoint = String($80c2d91c338af4a4$var$els.referencePoint?.value || "").trim();
    if (!referencePoint) {
        $80c2d91c338af4a4$var$showMessage("Informe o ponto de refer\xeancia.", "error");
        $80c2d91c338af4a4$var$els.referencePoint?.focus();
        return false;
    }
    return true;
}
function $80c2d91c338af4a4$var$validateStep4() {
    return true;
}
function $80c2d91c338af4a4$var$validateCurrentStep() {
    switch($80c2d91c338af4a4$var$STATE.currentStep){
        case 1:
            return $80c2d91c338af4a4$var$validateStep1();
        case 2:
            return $80c2d91c338af4a4$var$validateStep2();
        case 3:
            return $80c2d91c338af4a4$var$validateStep3();
        case 4:
            return $80c2d91c338af4a4$var$validateStep4();
        default:
            return true;
    }
}
/* =========================
   CEP + GEO
========================= */ async function $80c2d91c338af4a4$var$fetchCEP(cep) {
    const cleanCep = $80c2d91c338af4a4$var$onlyDigits(cep);
    if (cleanCep.length !== 8) throw new Error("CEP inv\xe1lido.");
    const url = `${$80c2d91c338af4a4$var$CONFIG.viacepBase}/${cleanCep}/json/`;
    const response = await fetch(url);
    if (!response.ok) throw new Error("Falha ao consultar o CEP.");
    const data = await response.json();
    if (data.erro) throw new Error("CEP n\xe3o encontrado.");
    return data;
}
async function $80c2d91c338af4a4$var$geocodeAddress() {
    const street = String($80c2d91c338af4a4$var$els.street?.value || "").trim();
    const number = String($80c2d91c338af4a4$var$els.number?.value || "").trim();
    const neighborhood = String($80c2d91c338af4a4$var$els.neighborhood?.value || "").trim();
    const city = String($80c2d91c338af4a4$var$els.city?.value || "").trim();
    const state = String($80c2d91c338af4a4$var$els.state?.value || "").trim();
    const cep = $80c2d91c338af4a4$var$onlyDigits($80c2d91c338af4a4$var$els.cep?.value);
    if (!street || !number || !city || !state) return null;
    const queryText = `${street}, ${number}, ${neighborhood}, ${city}, ${state}, Brasil, ${cep}`;
    const url = new URL($80c2d91c338af4a4$var$CONFIG.nominatimBase);
    url.searchParams.set("format", "jsonv2");
    url.searchParams.set("limit", "1");
    url.searchParams.set("countrycodes", "br");
    url.searchParams.set("q", queryText);
    const response = await fetch(url.toString(), {
        headers: {
            Accept: "application/json"
        }
    });
    if (!response.ok) throw new Error("Falha ao geocodificar endere\xe7o.");
    const results = await response.json();
    if (!Array.isArray(results) || !results.length) return null;
    const result = results[0];
    return {
        lat: Number(result.lat),
        lng: Number(result.lon),
        addressLabel: result.display_name || queryText
    };
}
async function $80c2d91c338af4a4$var$handleBuscarCep() {
    $80c2d91c338af4a4$var$clearMessage();
    try {
        const data = await $80c2d91c338af4a4$var$fetchCEP($80c2d91c338af4a4$var$els.cep?.value || "");
        if ($80c2d91c338af4a4$var$els.street) $80c2d91c338af4a4$var$els.street.value = data.logradouro || "";
        if ($80c2d91c338af4a4$var$els.neighborhood) $80c2d91c338af4a4$var$els.neighborhood.value = data.bairro || "";
        if ($80c2d91c338af4a4$var$els.city) $80c2d91c338af4a4$var$els.city.value = data.localidade || "";
        if ($80c2d91c338af4a4$var$els.state) $80c2d91c338af4a4$var$els.state.value = data.uf || "";
        $80c2d91c338af4a4$var$showMessage("CEP encontrado com sucesso.", "success");
        await $80c2d91c338af4a4$var$tryGeocodeWhenReady(true);
    } catch (error) {
        $80c2d91c338af4a4$var$resetGeo();
        $80c2d91c338af4a4$var$showMessage(error.message || "N\xe3o foi poss\xedvel buscar o CEP.", "error");
    }
}
async function $80c2d91c338af4a4$var$tryGeocodeWhenReady(force = false) {
    const requiredReady = String($80c2d91c338af4a4$var$els.street?.value || "").trim() && String($80c2d91c338af4a4$var$els.number?.value || "").trim() && String($80c2d91c338af4a4$var$els.city?.value || "").trim() && String($80c2d91c338af4a4$var$els.state?.value || "").trim();
    if (!requiredReady) {
        if (force) $80c2d91c338af4a4$var$resetGeo();
        return;
    }
    const requestId = ++$80c2d91c338af4a4$var$STATE.geoRequestId;
    try {
        const geo = await $80c2d91c338af4a4$var$geocodeAddress();
        if (requestId !== $80c2d91c338af4a4$var$STATE.geoRequestId) return;
        $80c2d91c338af4a4$var$STATE.geo = geo || {
            lat: null,
            lng: null,
            addressLabel: ""
        };
        $80c2d91c338af4a4$var$updateGeoPreview();
    } catch  {
        if (requestId !== $80c2d91c338af4a4$var$STATE.geoRequestId) return;
        $80c2d91c338af4a4$var$resetGeo();
    }
}
/* =========================
   PAYLOAD
========================= */ function $80c2d91c338af4a4$var$getSelectedDifficulty() {
    return $80c2d91c338af4a4$var$els.difficultyGroup?.querySelector(".choice-card.selected")?.dataset?.difficulty || "sim";
}
function $80c2d91c338af4a4$var$getProjectSourceLabel() {
    if (!$80c2d91c338af4a4$var$els.projectSource) return null;
    const selectedOption = $80c2d91c338af4a4$var$els.projectSource.options[$80c2d91c338af4a4$var$els.projectSource.selectedIndex];
    return selectedOption?.textContent?.trim() || null;
}
function $80c2d91c338af4a4$var$buildAddressLabel() {
    const cepDigits = $80c2d91c338af4a4$var$onlyDigits($80c2d91c338af4a4$var$els.cep?.value || "");
    const street = String($80c2d91c338af4a4$var$els.street?.value || "").trim();
    const number = String($80c2d91c338af4a4$var$els.number?.value || "").trim();
    const neighborhood = String($80c2d91c338af4a4$var$els.neighborhood?.value || "").trim();
    const city = String($80c2d91c338af4a4$var$els.city?.value || "").trim();
    const state = String($80c2d91c338af4a4$var$els.state?.value || "").trim().toUpperCase();
    const referencePoint = String($80c2d91c338af4a4$var$els.referencePoint?.value || "").trim();
    const enderecoCompleto = [
        street && number ? `${street}, ${number}` : street || number,
        neighborhood,
        city || state ? `${city}${city && state ? ", " : ""}${state}` : "",
        cepDigits ? `CEP ${$80c2d91c338af4a4$var$formatCEP(cepDigits)}` : "",
        "Brasil"
    ].filter(Boolean).join(" - ");
    return enderecoCompleto || referencePoint;
}
function $80c2d91c338af4a4$var$buildParticipantPayload() {
    const territoryId = $80c2d91c338af4a4$var$getCanonicalTerritoryId();
    const territoryLabel = $80c2d91c338af4a4$var$getCanonicalTerritoryLabel();
    const fullName = $80c2d91c338af4a4$var$capitalizeWords($80c2d91c338af4a4$var$normalizeName($80c2d91c338af4a4$var$els.fullName?.value || ""));
    const phoneDigits = $80c2d91c338af4a4$var$onlyDigits($80c2d91c338af4a4$var$els.phone?.value || "");
    const email = String($80c2d91c338af4a4$var$els.email?.value || "").trim().toLowerCase();
    const cpfDigits = $80c2d91c338af4a4$var$onlyDigits($80c2d91c338af4a4$var$els.cpf?.value || "");
    const cepDigits = $80c2d91c338af4a4$var$onlyDigits($80c2d91c338af4a4$var$els.cep?.value || "");
    const street = String($80c2d91c338af4a4$var$els.street?.value || "").trim();
    const number = String($80c2d91c338af4a4$var$els.number?.value || "").trim();
    const neighborhood = String($80c2d91c338af4a4$var$els.neighborhood?.value || "").trim();
    const city = String($80c2d91c338af4a4$var$els.city?.value || "").trim();
    const state = String($80c2d91c338af4a4$var$els.state?.value || "").trim().toUpperCase();
    const referencePoint = String($80c2d91c338af4a4$var$els.referencePoint?.value || "").trim();
    const difficulty = $80c2d91c338af4a4$var$getSelectedDifficulty();
    const householdMembers = String($80c2d91c338af4a4$var$els.householdMembers?.value || "").trim();
    const projectSource = String($80c2d91c338af4a4$var$els.projectSource?.value || "").trim() || null;
    const projectSourceLabel = $80c2d91c338af4a4$var$getProjectSourceLabel();
    const projectSourceOther = String($80c2d91c338af4a4$var$els.projectSourceOther?.value || "").trim() || null;
    return {
        name: fullName,
        fullName: fullName,
        nameLower: $80c2d91c338af4a4$var$slugify(fullName),
        phone: phoneDigits,
        email: email || null,
        cpf: cpfDigits || null,
        localType: $80c2d91c338af4a4$var$STATE.localType,
        codeLocalType: $80c2d91c338af4a4$var$getCodeLocalType(),
        registerType: $80c2d91c338af4a4$var$STATE.registerType,
        participantType: $80c2d91c338af4a4$var$STATE.registerType,
        participantCode: $80c2d91c338af4a4$var$STATE.generatedCode,
        cep: cepDigits || null,
        rua: street || null,
        street: street || null,
        numero: number || null,
        neighborhood: neighborhood || null,
        bairro: neighborhood || null,
        city: city || null,
        cidade: city || null,
        uf: state || null,
        state: state || null,
        referencePoint: referencePoint,
        enderecoCompleto: $80c2d91c338af4a4$var$buildAddressLabel(),
        address: $80c2d91c338af4a4$var$buildAddressLabel(),
        territoryId: territoryId,
        territoryLabel: territoryLabel,
        lat: $80c2d91c338af4a4$var$STATE.geo.lat ?? null,
        lng: $80c2d91c338af4a4$var$STATE.geo.lng ?? null,
        geoAddressLabel: $80c2d91c338af4a4$var$STATE.geo.addressLabel || "",
        consentLgpd: true,
        consentWhatsapp: true,
        consentImage: true,
        consentAccepted: true,
        difficulty: difficulty,
        householdMembers: householdMembers,
        projectSource: projectSource,
        projectSourceLabel: projectSourceLabel,
        projectSourceOther: projectSourceOther,
        status: "pending_approval",
        approvalStatus: "pending",
        origin: "public_form",
        source: "cadastro-publico",
        inTerritory: true,
        inOperation: false,
        active: false,
        createdAt: (0, $ilpIi.serverTimestamp)(),
        createdAtISO: new Date().toISOString()
    };
}
function $80c2d91c338af4a4$var$buildApprovalRequestPayload(participantId, participantData) {
    const territoryId = $80c2d91c338af4a4$var$getCanonicalTerritoryId();
    const territoryLabel = $80c2d91c338af4a4$var$getCanonicalTerritoryLabel();
    return {
        type: "participant_registration",
        targetCollection: "participants",
        targetId: participantId,
        territoryId: territoryId,
        territoryLabel: territoryLabel,
        participantCode: participantData.participantCode,
        participantName: participantData.name,
        participantEmail: participantData.email || null,
        participantPhone: participantData.phone,
        participantCpf: participantData.cpf || null,
        registerType: participantData.registerType,
        localType: participantData.localType,
        codeLocalType: participantData.codeLocalType,
        status: "pending",
        decision: null,
        reviewedAt: null,
        reviewedBy: null,
        reviewedByName: null,
        reviewNote: null,
        source: "cadastro-publico",
        summary: `Novo cadastro enviado por ${participantData.name} para aprova\xe7\xe3o da cooperativa.`,
        payloadSnapshot: {
            name: participantData.name,
            email: participantData.email || null,
            phone: participantData.phone,
            cpf: participantData.cpf || null,
            participantCode: participantData.participantCode,
            registerType: participantData.registerType,
            localType: participantData.localType,
            codeLocalType: participantData.codeLocalType,
            territoryId: territoryId,
            territoryLabel: territoryLabel,
            enderecoCompleto: participantData.enderecoCompleto,
            referencePoint: participantData.referencePoint,
            lat: participantData.lat ?? null,
            lng: participantData.lng ?? null,
            householdMembers: participantData.householdMembers,
            projectSource: participantData.projectSource,
            projectSourceLabel: participantData.projectSourceLabel,
            projectSourceOther: participantData.projectSourceOther
        },
        createdAt: (0, $ilpIi.serverTimestamp)(),
        createdAtISO: new Date().toISOString()
    };
}
async function $80c2d91c338af4a4$var$saveRegistration() {
    if (!$80c2d91c338af4a4$var$STATE.generatedCode || $80c2d91c338af4a4$var$STATE.generatedCode === "Ser\xe1 gerado ao concluir") {
        $80c2d91c338af4a4$var$STATE.generatedCode = await $80c2d91c338af4a4$var$generateSequentialCode();
        if ($80c2d91c338af4a4$var$els.generatedCode) $80c2d91c338af4a4$var$els.generatedCode.value = $80c2d91c338af4a4$var$STATE.generatedCode;
    }
    const participantPayload = $80c2d91c338af4a4$var$buildParticipantPayload();
    const participantRef = await (0, $ilpIi.addDoc)((0, $ilpIi.collection)((0, $hEplm.db), "participants"), participantPayload);
    const approvalRequestPayload = $80c2d91c338af4a4$var$buildApprovalRequestPayload(participantRef.id, participantPayload);
    const approvalRef = await (0, $ilpIi.addDoc)((0, $ilpIi.collection)((0, $hEplm.db), "approvalRequests"), approvalRequestPayload);
    return {
        participantId: participantRef.id,
        approvalRequestId: approvalRef.id,
        participantCode: participantPayload.participantCode
    };
}
/* =========================
   MODAL
========================= */ function $80c2d91c338af4a4$var$openSuccessModal() {
    if (!$80c2d91c338af4a4$var$els.successModal) return;
    $80c2d91c338af4a4$var$els.successModal.classList.remove("hidden");
    $80c2d91c338af4a4$var$els.successModal.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
}
function $80c2d91c338af4a4$var$closeSuccessModal() {
    if (!$80c2d91c338af4a4$var$els.successModal) return;
    $80c2d91c338af4a4$var$els.successModal.classList.add("hidden");
    $80c2d91c338af4a4$var$els.successModal.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
    window.location.href = $80c2d91c338af4a4$var$CONFIG.redirectAfterSuccess;
}
/* =========================
   EVENTS
========================= */ function $80c2d91c338af4a4$var$bindConsentButton() {
    const btn = document.getElementById("btnAcceptAllConsents");
    const note = document.getElementById("consentAcceptedNote");
    btn?.addEventListener("click", ()=>{
        $80c2d91c338af4a4$var$STATE.consentAccepted = true;
        if ($80c2d91c338af4a4$var$els.consentLgpd) $80c2d91c338af4a4$var$els.consentLgpd.checked = true;
        if ($80c2d91c338af4a4$var$els.consentWhatsapp) $80c2d91c338af4a4$var$els.consentWhatsapp.checked = true;
        if ($80c2d91c338af4a4$var$els.consentImage) $80c2d91c338af4a4$var$els.consentImage.checked = true;
        btn.classList.add("is-accepted");
        btn.innerHTML = "\u2705 Autoriza\xe7\xf5es confirmadas";
        btn.disabled = true;
        if (note) {
            note.classList.remove("hidden");
            note.style.display = "flex";
        }
        $80c2d91c338af4a4$var$clearMessage();
    });
}
function $80c2d91c338af4a4$var$bindProjectSourceSelect() {
    $80c2d91c338af4a4$var$els.projectSource?.addEventListener("change", ()=>{
        if (!$80c2d91c338af4a4$var$els.projectSourceOther) return;
        if ($80c2d91c338af4a4$var$els.projectSource.value === "outro") {
            $80c2d91c338af4a4$var$els.projectSourceOther.classList.remove("hidden");
            $80c2d91c338af4a4$var$els.projectSourceOther.focus();
        } else {
            $80c2d91c338af4a4$var$els.projectSourceOther.classList.add("hidden");
            $80c2d91c338af4a4$var$els.projectSourceOther.value = "";
        }
    });
}
function $80c2d91c338af4a4$var$bindStepNavigation() {
    document.querySelectorAll("[data-next-step]").forEach((button)=>{
        button.addEventListener("click", async ()=>{
            $80c2d91c338af4a4$var$clearMessage();
            if (!$80c2d91c338af4a4$var$validateCurrentStep()) return;
            if ($80c2d91c338af4a4$var$STATE.currentStep === 3) await $80c2d91c338af4a4$var$tryGeocodeWhenReady(true);
            $80c2d91c338af4a4$var$goToStep($80c2d91c338af4a4$var$STATE.currentStep + 1);
        });
    });
    document.querySelectorAll("[data-prev-step]").forEach((button)=>{
        button.addEventListener("click", ()=>{
            $80c2d91c338af4a4$var$clearMessage();
            $80c2d91c338af4a4$var$goToStep($80c2d91c338af4a4$var$STATE.currentStep - 1);
        });
    });
}
function $80c2d91c338af4a4$var$bindLocalTypeButtons() {
    const buttons = $80c2d91c338af4a4$var$els.localTypeGroup?.querySelectorAll("[data-local-type]") || [];
    buttons.forEach((button)=>{
        button.addEventListener("click", async ()=>{
            await $80c2d91c338af4a4$var$setLocalType(button.dataset.localType);
            $80c2d91c338af4a4$var$clearMessage();
        });
    });
}
function $80c2d91c338af4a4$var$bindRegisterTypeButtons() {
    const buttons = $80c2d91c338af4a4$var$els.registerTypeGroup?.querySelectorAll("[data-register-type]") || [];
    buttons.forEach((button)=>{
        button.addEventListener("click", async ()=>{
            if (button.classList.contains("is-disabled")) return;
            await $80c2d91c338af4a4$var$setRegisterType(button.dataset.registerType, true);
            $80c2d91c338af4a4$var$clearMessage();
        });
    });
}
function $80c2d91c338af4a4$var$bindDifficultyButtons() {
    const buttons = $80c2d91c338af4a4$var$els.difficultyGroup?.querySelectorAll("[data-difficulty]") || [];
    buttons.forEach((button)=>{
        button.addEventListener("click", ()=>{
            buttons.forEach((btn)=>btn.classList.remove("selected"));
            button.classList.add("selected");
        });
    });
}
function $80c2d91c338af4a4$var$bindFormatters() {
    $80c2d91c338af4a4$var$els.phone?.addEventListener("input", (event)=>{
        event.target.value = $80c2d91c338af4a4$var$formatPhone(event.target.value);
    });
    $80c2d91c338af4a4$var$els.cpf?.addEventListener("input", (event)=>{
        event.target.value = $80c2d91c338af4a4$var$formatCPF(event.target.value);
    });
    $80c2d91c338af4a4$var$els.cep?.addEventListener("input", (event)=>{
        event.target.value = $80c2d91c338af4a4$var$formatCEP(event.target.value);
    });
}
function $80c2d91c338af4a4$var$bindGeoEvents() {
    $80c2d91c338af4a4$var$els.btnBuscarCep?.addEventListener("click", $80c2d91c338af4a4$var$handleBuscarCep);
    [
        "number",
        "street",
        "neighborhood",
        "city",
        "state",
        "cep"
    ].forEach((id)=>{
        const el = $80c2d91c338af4a4$var$$(id);
        if (!el) return;
        el.addEventListener("change", async ()=>{
            await $80c2d91c338af4a4$var$tryGeocodeWhenReady(false);
        });
        el.addEventListener("blur", async ()=>{
            await $80c2d91c338af4a4$var$tryGeocodeWhenReady(false);
        });
    });
}
function $80c2d91c338af4a4$var$bindMenu() {
    $80c2d91c338af4a4$var$els.menuToggle?.addEventListener("click", ()=>{
        $80c2d91c338af4a4$var$els.mobileMenu?.classList.toggle("show");
        $80c2d91c338af4a4$var$els.mobileMenu?.classList.toggle("open");
    });
}
function $80c2d91c338af4a4$var$bindSuccessModal() {
    $80c2d91c338af4a4$var$els.closeSuccessModal?.addEventListener("click", $80c2d91c338af4a4$var$closeSuccessModal);
    $80c2d91c338af4a4$var$els.newParticipantRegistration?.addEventListener("click", ()=>{
        window.location.reload();
    });
    $80c2d91c338af4a4$var$els.successModal?.querySelector(".success-modal-backdrop")?.addEventListener("click", $80c2d91c338af4a4$var$closeSuccessModal);
}
function $80c2d91c338af4a4$var$bindSubmit() {
    $80c2d91c338af4a4$var$els.form?.addEventListener("submit", async (event)=>{
        event.preventDefault();
        $80c2d91c338af4a4$var$clearMessage();
        if ($80c2d91c338af4a4$var$STATE.isSubmitting) return;
        if (!$80c2d91c338af4a4$var$validateStep1()) return;
        if (!$80c2d91c338af4a4$var$validateStep2()) return;
        if (!$80c2d91c338af4a4$var$validateStep3()) return;
        if (!$80c2d91c338af4a4$var$validateStep4()) return;
        $80c2d91c338af4a4$var$STATE.isSubmitting = true;
        $80c2d91c338af4a4$var$setLoading($80c2d91c338af4a4$var$els.btnSubmitParticipant, true, "Enviando cadastro...");
        try {
            await $80c2d91c338af4a4$var$tryGeocodeWhenReady(true);
            const result = await $80c2d91c338af4a4$var$saveRegistration();
            $80c2d91c338af4a4$var$showMessage(`Cadastro enviado com sucesso para an\xe1lise da cooperativa. C\xf3digo gerado: ${result.participantCode}`, "success");
            $80c2d91c338af4a4$var$openSuccessModal();
        } catch (error) {
            console.error("Erro ao salvar cadastro:", error);
            $80c2d91c338af4a4$var$showMessage(error?.message || "N\xe3o foi poss\xedvel enviar o cadastro. Verifique as regras do Firestore para participants e approvalRequests.", "error");
        } finally{
            $80c2d91c338af4a4$var$STATE.isSubmitting = false;
            $80c2d91c338af4a4$var$setLoading($80c2d91c338af4a4$var$els.btnSubmitParticipant, false);
        }
    });
}
/* =========================
   INIT
========================= */ function $80c2d91c338af4a4$var$initStaticTexts() {
    if ($80c2d91c338af4a4$var$els.territoryLabelView) $80c2d91c338af4a4$var$els.territoryLabelView.textContent = $80c2d91c338af4a4$var$getCanonicalTerritoryLabel();
    if ($80c2d91c338af4a4$var$els.userNameView) $80c2d91c338af4a4$var$els.userNameView.textContent = "Cadastro p\xfablico";
}
async function $80c2d91c338af4a4$var$initDefaults() {
    $80c2d91c338af4a4$var$STATE.consentAccepted = false;
    if ($80c2d91c338af4a4$var$els.consentLgpd) $80c2d91c338af4a4$var$els.consentLgpd.checked = true;
    if ($80c2d91c338af4a4$var$els.consentWhatsapp) $80c2d91c338af4a4$var$els.consentWhatsapp.checked = true;
    if ($80c2d91c338af4a4$var$els.consentImage) $80c2d91c338af4a4$var$els.consentImage.checked = true;
    if ($80c2d91c338af4a4$var$els.projectSourceOther) $80c2d91c338af4a4$var$els.projectSourceOther.classList.add("hidden");
    $80c2d91c338af4a4$var$updateGeoPreview();
    $80c2d91c338af4a4$var$updateProgress();
    try {
        await $80c2d91c338af4a4$var$setLocalType("casa");
    } catch (error) {
        console.warn("N\xe3o foi poss\xedvel gerar o c\xf3digo inicial:", error);
        if ($80c2d91c338af4a4$var$els.generatedCode) $80c2d91c338af4a4$var$els.generatedCode.value = "Ser\xe1 gerado ao concluir";
    }
}
async function $80c2d91c338af4a4$var$init() {
    try {
        $80c2d91c338af4a4$var$assertRuntimeConfig();
        $80c2d91c338af4a4$var$initStaticTexts();
        $80c2d91c338af4a4$var$bindConsentButton();
        $80c2d91c338af4a4$var$bindStepNavigation();
        $80c2d91c338af4a4$var$bindLocalTypeButtons();
        $80c2d91c338af4a4$var$bindRegisterTypeButtons();
        $80c2d91c338af4a4$var$bindDifficultyButtons();
        $80c2d91c338af4a4$var$bindProjectSourceSelect();
        $80c2d91c338af4a4$var$bindFormatters();
        $80c2d91c338af4a4$var$bindGeoEvents();
        $80c2d91c338af4a4$var$bindMenu();
        $80c2d91c338af4a4$var$bindSuccessModal();
        $80c2d91c338af4a4$var$bindSubmit();
        await $80c2d91c338af4a4$var$initDefaults();
    } catch (error) {
        console.error("Erro ao iniciar formul\xe1rio:", error);
        $80c2d91c338af4a4$var$showMessage(error?.message || "N\xe3o foi poss\xedvel iniciar o formul\xe1rio.", "error");
    }
}
$80c2d91c338af4a4$var$init();


//# sourceMappingURL=cadastro-participantes-padre-cacique.c0410951.js.map
